const hotels = {
  accommodation: "숙소", // translated 
  hotel: "호텔", // translated 
  hotels: "호텔", // translated 
  back: "뒤쪽에", // translated 
  rooms: "객실", // translated 
  viewPictures: "사진 보기", // translated 
  showMore: "더 보기", // translated 
  bookingInformation: "예약 정보", // translated 
  cancellationPolicy: "취소 정책", // translated 
  from: "에서", // translated 
  to: "Προς την", // translated 
  cancellationIs: "취소는", // translated 
  free: "무료", // translated 
  chargeableWithFeeOf: "수수료가 부과될 수 있음", // translated 
  prebook: "사전 예약", // translated 
  guests: "손님", // translated 
  payment: "지불", // translated 
  byClicking: "클릭하시면", // translated 
  next: "다음", // translated 
  youAreAgreeingToOur: "귀하는 당사의 약관에 동의하는 것입니다.", // translated 
  termsAndConditions: "이용약관", // translated 
  previous: "이전의", // translated 
  cancel: "취소", // translated 
  mealPlan: "식단 계획", // translated 
  roomType: "객실 유형", // translated 
  description: "설명", // translated 
  readLess: "간략히 보기", // translated 
  readMore: "더 읽어보기", // translated 
  facilities: "시설", // translated 
  viewLess: "간략히 보기", // translated 
  viewMore: "더 보기", // translated 
  less: "더 적은", // translated 
  more: "더", // translated 
  notAvailable_short: "해당 없음", // translated 
  backToHotelList: "호텔 목록으로 돌아가기", // translated 
  viewOnMap: "지도에서 보기", // translated 
  sleeps: "잠", // translated 
  adults: "성인", // translated 
  yearsOld: "세", // translated 
  type: "유형", // translated 
  bedding: "침구", // translated 
  selectRoom: "객실 선택", // translated 
  selectRooms: "객실 선택", // translated 
  city: "도시", // translated 
  checkIn: "체크인", // translated 
  checkOut: "체크아웃", // translated 
  date: "날짜", // translated 
  dates: "날짜", // translated 
  persons: "명", // translated 
  stillOnTrialQuestionToUpgrade:
    "앗! 아직 체험 회원 기간이시네요. 예약하시려면 정식 회원이 되셔야 합니다. 지금 업그레이드하시겠습니까?", // translated 
  stillOnTrialQuestionToUpgradeNonElligib:
    "앗! 아직 구독 회원이 아니신 것 같네요. 예약하려면 정식 회원으로 가입하셔야 합니다. 지금 업그레이드하시겠습니까?", // translated 
  completeProfile: "먼저 사용자 프로필을 작성해 주세요.", // translated 
  upgrade: "Αναβαθμίζω", // translated 
  close: "닫다", // translated 
  viewDetails: "상세 정보 보기", // translated 
  name: "이름", // translated 
  rating: "평가", // translated 
  budget: "예산", // translated 
  orderBy: "정렬 기준", // translated 
  priceLowestFirst: "가격 (낮은 가격부터)", // translated 
  priceHighestFirst: "가격 (높은 순서대로)", // translated 
  ratingLowestFirst: "평점 (낮은 순)", // translated 
  ratingHighestFirst: "평점 (높은 순서대로)", // translated 
  starRatingAndPrice: "별점 및 가격", // translated 
  biggestSavingsFirst: "가장 큰 할인 혜택부터", // translated 
  select: "선택하다", // translated 
  reset: "다시 놓기", // translated 
  apply: "적용하다", // translated 
  filterBy: "필터 기준", // translated 
  myProfile: "내 프로필", // translated 
  login: "로그인", // translated 
  roomOnly: "객실만", // translated 
  bedAndBreakfast: "민박", // translated 
  halfBoard: "하프보드", // translated 
  fullBoard: "풀보드", // translated 
  allInclusive: "올인클루시브", // translated 
  filter: "필터", // translated 
  mapView: "지도 보기", // translated 
  results: "결과", // translated 
  listView: "목록 보기", // translated 
  newSearch: "새로운 검색", // translated 
  editSearch: "검색 수정", // translated 
  all: "모두", // translated 
  multiple: "다수의", // translated 
  editProfile: "프로필 수정", // translated 
  backToHotelsList: "호텔 목록으로 돌아가기", // translated 
  roomName: "객실 이름", // translated 
  mealType: "식사 종류", // translated 
  freeCancellation: "무료 취소", // translated 
  yes: "예", // translated 
  no: "오키", // translated 
  filters: "필터", // translated 
  cancellationNonRefundable: "취소 시 환불은 불가합니다.", // translated 
  hotelRating: "호텔 평점", // translated 
  any: "어느", // translated 
  off: "끄다", // translated 
  performNewSearch: "새로운 검색을 수행하세요", // translated 
};


export default hotels;
